import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { ResponsiveImage, Footer } from '../../components';
import dogInABox from '../../images/mx-dog-in-a-box.png';
import { LinkButton, Heading } from '../../atoms';
import { FOOTER_CONTENT } from '../../testing/constants';
import {
  BaseHeader,
  DiscountBanner,
  LeftMenuLinks,
  CenterMenuLinks,
  LOGGEDIN_LINKS,
  LOGGEDOUT_LINKS,
  UserMenuLinks,
} from '../../molecules';
import { useSessionCustomer } from '../../customer';
import { useReporter } from '../../reporter';
import { errorPageCopy, errorPageHeader } from './constants';
import {
  StyledErrorPage,
  Paragraph,
  ErrorWrapper,
  HeadingContainer,
} from './styles.js';
import { errorPageView } from './events';

export const ErrorPage = ({ statusCode }) => {
  const { isActive } = useSessionCustomer();
  const reporter = useReporter();

  useEffect(() => {
    reporter.tag(errorPageView(statusCode));
  }, [reporter, statusCode]);

  return (
    <StyledErrorPage>
      <BaseHeader
        leftSegment={
          <LeftMenuLinks
            // TODO(James) get links from CMS
            links={isActive ? LOGGEDIN_LINKS : LOGGEDOUT_LINKS}
          />
        }
        topSegment={!isActive ? <DiscountBanner /> : null}
        centerSegment={
          <CenterMenuLinks
            links={isActive ? LOGGEDIN_LINKS : LOGGEDOUT_LINKS}
          />
        }
        rightSegment={<UserMenuLinks />}
        logoUrl="/"
        logoSrText="Ollie logo"
      />
      <ErrorWrapper>
        <ResponsiveImage
          src={dogInABox}
          alt="Dog in an Ollie box"
          height={270}
          width={270}
        />
        <HeadingContainer>
          <Heading
            headingLevel="h1"
            typography={'headingMastiff'}
            headingText={errorPageHeader[statusCode]}
            position="center"
          />
        </HeadingContainer>
        <Paragraph>{errorPageCopy[statusCode]}</Paragraph>
        {statusCode !== 503 && (
          <LinkButton
            href="/account"
            horizontalPadding={22}
            verticalPadding={4}
          >
            Back To Dashboard
          </LinkButton>
        )}
      </ErrorWrapper>
      <Footer {...FOOTER_CONTENT} />
    </StyledErrorPage>
  );
};

ErrorPage.displayName = 'ErrorPage';

ErrorPage.propTypes = {
  statusCode: PropTypes.oneOf([400, 404, 500, 503]).isRequired,
};
